import { FC } from 'react'
import { TBlogPostSummary } from 'common/cms-types'
import Link from 'next/link'
import { linkResolver } from '../../linkResolver'
import PrismicImage from 'components/PrismicImage'
import useWindowSize from 'components/util/useWindowSize' // we need this to make JSX compile

type RelatedArticleType = {
  post: TBlogPostSummary
}

const RelatedBlogPost: FC<RelatedArticleType> = ({ post }) => {
  const windowSize = useWindowSize()
  return (
    <Link className='a-unstyled' href={linkResolver(post as any)}>
      <div className='cursor-pointer blog-results__item blog-results__item--sm'>
        <div
          className={`blog-results__img-container blog-results__img-container--sm`}
        >
          <PrismicImage image={post.data.main_image} />
        </div>
        <div className={'px-4 pt-4 pb-md-18 pb-10'}>
          {windowSize.isMdOrLower ? (
            <>
              <p className={'text-xs text-muted mb-2'}>
                {post.data.published_date}
              </p>
              <p className={'lead text-bold mb-0'}>{post.data.title}</p>
            </>
          ) : (
            <>
              <p className={'text-large text-semibold'}>{post.data.title}</p>
              <p className={'text-small-m text-muted mb-0'}>
                {post.data.published_date}
              </p>
            </>
          )}
        </div>
      </div>
    </Link>
  )
}

export default RelatedBlogPost
